import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import MiniOverlayModal from 'dpl/common/mini_overlay_modal/components/MiniOverlayModal';
import { isMobileUA } from 'dpl/shared/utils';
import MobileMenu from 'dpl/components/MobileMenu';
import Icon from 'dpl/common/components/Icon';

import { PAYMENT_TIER_TYPE, SELECT_PAYMENT_MODAL_NAME } from './constants';
import SelectPaymentType from './SelectPaymentType';
import SelectPaymentTypeLearnMore from './SelectPaymentTypeLearnMore';

const IS_MOBILE_UA = isMobileUA();

function CurrentModalDisplay({
  amount,
  fee,
  dogPayment,
  currentModalName,
  onGoBack,
  onChangeModal,
  onHandleSelection,
  onSave,
  onCloseClick,
  selectedProtectionType
}) {
  const learnMoreProps = { onGoBack, dogPayment, amount, onChangeModal };
  const paymentProtectionProps = {
    onChangeModal,
    selectedProtectionType,
    amount,
    fee,
    dogPayment,
    onHandleSelection,
    onSave,
    onCloseClick
  };

  const mapModalNameToModalComponent = {
    [SELECT_PAYMENT_MODAL_NAME.LEARN_MORE]: (
      <SelectPaymentTypeLearnMore {...learnMoreProps} />
    ),
    [SELECT_PAYMENT_MODAL_NAME.PAYMENT_PROTECTION]: (
      <SelectPaymentType {...paymentProtectionProps} />
    )
  };

  return mapModalNameToModalComponent[currentModalName];
}

export default function SelectPaymentTypeParentModal(props) {
  const [currentModalName, setCurrentModalName] = useState(
    props.defaultModalName
  );
  const [previousModalName, setPreviousModalName] = useState(null);
  const [selectedProtectionType, setSelectedProtectionType] = useState(
    props.paymentTier
  );
  const [isMenuOpen, setIsMenuOpen] = useState(true);

  function handleChangeModal(newModalName, allowGoBack = false) {
    allowGoBack
      ? setPreviousModalName(currentModalName)
      : setPreviousModalName(null);
    setCurrentModalName(newModalName);
  }

  function handleGoBack() {
    setCurrentModalName(previousModalName);
    setPreviousModalName(null);
  }

  function handleSelection(type) {
    setSelectedProtectionType(type);
  }

  function handleSaveSelection() {
    props.onSaveSelection(selectedProtectionType);
  }

  if (IS_MOBILE_UA) {
    return (
      <div className="SelectPaymentTypeParentModal">
        <div
          className={classnames(
            'scrim--black fixed z-max left-0 top-0 right-0 bottom-0 transition pointer-events-none',
            {
              'o-0': !isMenuOpen,
              'o-100': isMenuOpen
            }
          )}
        />
        <MobileMenu
          className="no-scrollbars pt6"
          position="bottom"
          isOpen={isMenuOpen}
        >
          <div className="SelectPaymentTypeParentModal__mobileMenu flex flex-column bg-white min-h-100 overflow-y-auto">
            <div className="w-100 flex justify-end pv4 mb2 bb b--lightest-gray">
              <button
                type="button"
                onClick={() => {
                  setIsMenuOpen(false);
                  props.onCloseClick();
                }}
              >
                <Icon
                  name="close"
                  className="ph2 pv2 mr4 ba b--light-gray br-100"
                  height="32px"
                  width="32px"
                />
              </button>
            </div>
            <CurrentModalDisplay
              currentModalName={currentModalName}
              onChangeModal={handleChangeModal}
              onGoBack={previousModalName && handleGoBack}
              onHandleSelection={handleSelection}
              selectedProtectionType={selectedProtectionType}
              onSave={handleSaveSelection}
              {...props}
            />
          </div>
        </MobileMenu>
      </div>
    );
  }

  return (
    <MiniOverlayModal
      className="SelectPaymentTypeParentModal"
      onCloseClick={props.onCloseClick}
      hideCloseButton={Boolean(previousModalName)}
    >
      <CurrentModalDisplay
        currentModalName={currentModalName}
        onChangeModal={handleChangeModal}
        onGoBack={previousModalName && handleGoBack}
        onHandleSelection={handleSelection}
        selectedProtectionType={selectedProtectionType}
        onSave={handleSaveSelection}
        {...props}
      />
    </MiniOverlayModal>
  );
}

SelectPaymentTypeParentModal.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  onSaveSelection: PropTypes.func.isRequired,
  defaultModalName: PropTypes.string,
  amount: PropTypes.number.isRequired,
  dogPayment: PropTypes.bool.isRequired,
  paymentTier: PropTypes.oneOf(Object.values(PAYMENT_TIER_TYPE)).isRequired
};

SelectPaymentTypeParentModal.defaultProps = {
  defaultModalName: SELECT_PAYMENT_MODAL_NAME.PAYMENT_PROTECTION
};
